import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement("g", { fill: "#333" }, /* @__PURE__ */ a.createElement("path", { d: "M13.228 21.75H4.194a.639.639 0 01-.638-.64V10.25a.639.639 0 01.638-.64h17.25a.639.639 0 01.64.64v2.644a9.177 9.177 0 012.555 0V4.5a1.278 1.278 0 00-1.278-1.277h-3.194a.32.32 0 01-.32-.32V1.624a.958.958 0 00-1.917 0v4.792a.958.958 0 11-1.916 0V3.86a.639.639 0 00-.639-.638h-5.43a.32.32 0 01-.32-.32V1.624a.958.958 0 10-1.917 0v4.792a.958.958 0 01-1.916 0V3.86a.639.639 0 00-.64-.638H2.279A1.278 1.278 0 001 4.499v17.25a2.556 2.556 0 002.556 2.556h9.672a9.177 9.177 0 010-2.556z" }), /* @__PURE__ */ a.createElement("path", { d: "M31.666 22.666a1.87 1.87 0 00-1.846-1.846h-3.692a.615.615 0 01-.616-.616v-3.692a1.846 1.846 0 10-3.692 0v3.692a.615.615 0 01-.616.616h-3.692a1.846 1.846 0 000 3.692h3.692a.615.615 0 01.616.616v3.692a1.846 1.846 0 003.692 0v-3.692a.615.615 0 01.616-.616h3.692a1.87 1.87 0 001.846-1.846z" }))
);
export {
  t as default
};
